
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/articleEditor",
      function () {
        return require("private-next-pages/dashboard/articleEditor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/articleEditor"])
      });
    }
  